import IconPlay from '@fortuneo/ui-icons/general/IconPlay'
import { withDisplayName } from '@hocs/with-display-name'
import Loader from '@ui/atoms/loader'
import { graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React, { Suspense, useCallback, useState } from 'react'

const YoutubePlayerModal = React.lazy(async () => ({
  default: (await import('@ui/youtube-player-modal')).YoutubePlayerModal,
}))

const ContentfulYoutubePlayer: Utils.EntryFC<
  Queries.ContentfulYoutubePlayerFragment
> = ({ content: { url, mode, thumbnail }, entryInspectorProps }) => {
  const [isOpen, setIsOpen] = useState(false)
  const videoId = new URL(url).searchParams.get('v')

  const onClick = useCallback(() => {
    setIsOpen(true)
  }, [])

  const onClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <>
      <div
        className="group relative aspect-square w-full overflow-hidden rounded-[24px] group-[.blog-article-template-block]/content-type:my-8 group-[.faq-page-template-block]/content-type:my-8 group-[.visual-alternation-block]/content-type:aspect-square tablet:aspect-[16/8]"
        {...entryInspectorProps()}
      >
        <button
          aria-hidden
          className="absolute inset-0 z-[999] flex cursor-pointer items-center justify-center"
          type="button"
          onClick={onClick}
        >
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-background-default/50 transition-all group-hover:scale-125">
            <IconPlay className="ml-1 size-8 fill-text-default" />
          </div>
        </button>
        <GatsbyImage
          alt={thumbnail.description}
          className="h-full transition-all group-hover:scale-105"
          image={getImage(thumbnail)}
        />
      </div>
      {isOpen && (
        <Suspense fallback={<Loader />}>
          <YoutubePlayerModal
            isOpen={isOpen}
            mode={mode}
            videoId={videoId}
            onClose={onClose}
          />
        </Suspense>
      )}
    </>
  )
}

export const query = graphql`
  fragment ContentfulYoutubePlayerAsset on ContentfulAsset {
    ...Asset
    gatsbyImageData(
      placeholder: BLURRED
      layout: FULL_WIDTH
      formats: [AVIF, WEBP, AUTO]
    )
  }

  fragment ContentfulYoutubePlayer on ContentfulPlayerYoutube {
    ...ContentfulEntry
    url
    mode
    thumbnail {
      ...ContentfulYoutubePlayerAsset
    }
  }
`

export default withDisplayName(
  ContentfulYoutubePlayer,
  'ContentfulYoutubePlayer'
)
